module.exports = __webpack_public_path__ + "static/media/xiddig.58d11849.png";